import { mobileMediaQuery } from 'common/constants/mediaQueries'
import { CommonImageInterface } from 'common/types/entities/ImageInterface'
import { addUrlSchemaToTheLink } from 'common/utils/urlUtils'
import React from 'react'
import ImageBackgroundUi from './ui/ImageBackgroundUi'
import ImageUi from './ui/ImageUi'
import ImageWrapperUi from './ui/ImageWrapperUi'
import PictureUi from './ui/PictureUi'

export enum ImageActionEnum {
  ShowPopup = 'ShowPopup',
  OpenUrl = 'OpenUrl',
}

interface ImageProps extends CommonImageInterface {
  src: string
  mobileSrc?: string
  attrId: string
  loading?: 'lazy' | 'eager'
  onClick?: (e: React.SyntheticEvent) => void
  pointer?: boolean
  link?: string
  openNewTab?: boolean
}

const Image = ({
  attrId,
  alt,
  ratio,
  mobileRatio,
  blur,
  border,
  src,
  mobileSrc,
  width,
  mobileWidth,
  loading = 'lazy',
  boxShadow,
  mobileBoxShadow,
  alignSelf,
  mobileAlignSelf,
  onClick,
  pointer = false,
  link,
  openNewTab,
  mobileBorder,
  background,
  mobileBackground,
}: ImageProps) => {
  const isBackgroundSet = background || mobileBackground
  const pictureContent = (
    <PictureUi ratio={ratio} mobileRatio={mobileRatio}>
      {mobileSrc && <source media={mobileMediaQuery} srcSet={mobileSrc} />}
      {isBackgroundSet ? (
        <ImageBackgroundUi
          border={border}
          mobileBorder={mobileBorder}
          width={width}
          onClick={onClick}
          mobileWidth={mobileWidth}
          background={background}
          mobileBackground={mobileBackground}
        />
      ) : null}
      <ImageUi
        onClick={onClick}
        pointer={pointer}
        id={attrId}
        src={src}
        alt={alt}
        width={width}
        mobileWidth={mobileWidth}
        fullHeight={!ratio && !mobileRatio}
        blur={blur}
        border={isBackgroundSet ? undefined : border}
        mobileBorder={isBackgroundSet ? undefined : mobileBorder}
        borderRadius={isBackgroundSet ? border?.radius : undefined}
        mobileBorderRadius={isBackgroundSet ? mobileBorder?.radius : undefined}
        loading={loading}
        boxShadow={boxShadow}
        mobileBoxShadow={mobileBoxShadow}
      />
    </PictureUi>
  )

  return (
    <ImageWrapperUi
      alignSelf={alignSelf}
      mobileAlignSelf={mobileAlignSelf}
      width={width}
      mobileWidth={mobileWidth}
      ratio={ratio}
      mobileRatio={mobileRatio}
    >
      {link ? (
        <a
          href={addUrlSchemaToTheLink(link)}
          rel="noopener noreferrer"
          target={openNewTab ? '_blank' : '_self'}
        >
          {pictureContent}
        </a>
      ) : (
        pictureContent
      )}
    </ImageWrapperUi>
  )
}

export default Image
